import React from 'react';
import utils from '../../../utils';
import fetch from '../../fetch';
import {Modal,message,Progress,Tag} from 'antd';
const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}


const columnsArray = [
    {type: 'selection'},
    {key:'$index', label: '序号'},
    { key: 'orgName', label: '部门名称', width: 120 },
    { key: 'projectName', label: '项目名称', width: 120 },
    { key: 'folderName', label: '项目目录', width: 120 },
    {key:'reviewStatus', label: '评审状态', width: 120, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待评审</Tag> : +d >= 2 ? <Tag color='#52c41a'>已评审</Tag> : <Tag color='#1890ff'>未开始</Tag>)},
    {
        key: 'reviewScore', width: 100,
        label: '评审分数',
    },
    {
        key: 'reviewGrade', width: 100,
        label: '评审等级',
    },
    {
        key: 'masterName', width: 100,
        label: '评审专家'
    },
    { key: 'employeeName', label: '录入人', width: 120 },
    { key: 'projectLeaderName', label: '项目负责人', width: 120 },
    {
        key: 'termName', width: 120,
        label: '所属学期'
    }
]

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},
    { key: 'orgName', label: '部门名称', width: 120 },
    { key: 'projectName', label: '项目名称', width: 120 },
    { key: 'folderName', label: '项目目录', width: 120 },
    {key:'reviewStatus', label: '评审状态', width: 120, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待评审</Tag> : +d >= 2 ? <Tag color='#52c41a'>已评审</Tag> : <Tag color='#1890ff'>未开始</Tag>)},
    {
        key: 'reviewScore', width: 100,
        label: '评审分数',
    },
    {
        key: 'reviewGrade', width: 100,
        label: '评审等级',
    },
    {
        key: 'masterName', width: 100,
        label: '评审专家'
    },
    { key: 'employeeName', label: '录入人', width: 120 },
    { key: 'projectLeaderName', label: '项目负责人', width: 120 },
    {
        key: 'termName', width: 120,
        label: '所属学期'
    }
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    return fetch.post('project/expert/review/query?'+ params.join('&'), Object.assign({
        type: "view"
    }, defaultsParams, newKeyword))
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta,
            headers: utils.columns(columnsArray)
        };
    })
    .then(res => (Object.assign({
        headers: res.headers,
        result: (res.data.dataList || []).map(d => {
            return Object.assign({}, d, {
                height: (d.fileMaxRow != null ? d.fileMaxRow * 30 : 30)
            })
        }),
        selects: (res.data.dataList || []).map((d,i) => ({
            value: d.id,
            checked: false,
            height: (d.fileMaxRow != null ? d.fileMaxRow * 30 : 30)
        })),
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const auditInsert = (domain) => {
    return fetch.post('project/expert/review/insert' , domain)
    .then(response =>{
        return response
    })
}

const auditSave= (domain) => {
    return fetch.post('project/expert/review/save' , domain)
    .then(response =>{
        return response
    })
}

/**
 * @method batchBack
 * @return {promise}
 */
const batchBack = (callback) => {
    return fetch.post('project/expert/review/batch/back', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }

        callback();
        return response;
    });
}

const batchSubmitAudit = (callback) => {
    return fetch.post('project/expert/review/batch/submitAudit', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }

        callback();
        return response;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('project/expert/review/delete/', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        callback();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

const querySearchByGrade = (keywords ={}) => {
    return fetch.post('project/expert/review/grade', keywords)
    .then(response => {
        const gradeList = response.payload.data.grade.map(d => ({
            value: d.value,
            label: d.label
        }));
        return {
            data: gradeList,
            label: response.payload.data.label
        };
    });
}

const getReviewDetailById = (id) => {
    return fetch.get(`project/expert/review/getDetailById/${id}`)
}

export default {
    setRefresh,
    onSelect,
    getSelection,
    headers,
    querySearch,
    auditInsert,
    auditSave,
    batchBack,
    batchSubmitAudit,
    remove,
    batchRemove,
    querySearchByGrade,
    getReviewDetailById
}